"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = exports.assertNever = void 0;
function assertNever(_value, message) {
    throw new Error(message);
}
exports.assertNever = assertNever;
function isDefined(value) {
    return value != null;
}
exports.isDefined = isDefined;
//# sourceMappingURL=utils.js.map